import type { IClaimsContent } from '../../types';
import * as m from '@/paraglide/messages.js';

export const getClaimsContent = (): IClaimsContent => ({
  medicalClaimForm: {
    href: '/HMCVTC_Claim_Form_EN_20230518.pdf',
    title: m.tis_claims_medical_title(),
    description: m.tis_claims_medical_description(),
  },
  nonMedicalClaimForm: {
    href: '',
    title: m.tis_claims_non_medical_title(),
    description: m.tis_claims_non_medical_description(),
  },
  authorizationText: '',
});
